import * as types from './constants/index'

const initialState = {
    currentCapsule: null,
    singleError: null,
    capsuleList: null,
    count: null,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case types.SAVE_CAPSULE:
            return {
                ...state,
                currentCapsule: action.payload,
            }

        case types.CAPSULE_ERROR:
            return{
                ...state,
                singleError: action.payload,
            }
        
        case types.CLEAR_CAPSULE:
            return{
                ...state,
                currentCapsule: null
            }

        case types.GET_ALL:
            return{
                ...state,
                capsuleList: action.payload
            }

        case types.LOAD_CAPSULE:
            return {
                ...state,
                currentCapsule: action.payload
            }

        case types.CAPSULE_COUNT:
            return {
                ...state,
                count: action.payload
            }

        case types.LOGOUT:
            return {
                ...state,
                currentCapsule: null,
                capsuleList: null,
                count: null,
            }
            
        default:
            return state;
    }
}